import { Tag } from "antd";
import React, { forwardRef, useEffect } from "react";
import { useApi } from "src/Api/useApi";
import styles from "./NeurapulseProjectDisplay.module.css";
import { NeurapulseProject } from "src/@types/ImpiricaPlatformApi";
import { LoadingIndicator } from "./LoadingIndicator";
import clsx from "clsx";

type NeurapulseProjectProps = {
	// Add your props here
	organizationId?: number;
	datasetId?: number;
};

export const NeurapulseProjectDisplay = forwardRef<
	HTMLDivElement,
	NeurapulseProjectProps
>(({ organizationId, datasetId }, ref) => {
	const { neurapulseClient } = useApi();
	const [project, setProject] = React.useState<NeurapulseProject | null>(null);
	const [loading, setLoading] = React.useState(false);
	const [error, setError] = React.useState<string | null>(null);
	useEffect(() => {
		const fetchProjectDetails = async () => {
			if (organizationId && datasetId && neurapulseClient) {
				setLoading(true);
				setError(null);
				try {
					const p = await neurapulseClient.getNeurapulseProject(
						organizationId,
						datasetId
					);
					setProject(p);
				} catch (e: any) {
					console.error("Error fetching Neurapulse project:", e);
					setError("Failed to load project");
				} finally {
					setLoading(false);
				}
			}
		};
		fetchProjectDetails();
	}, [organizationId, datasetId, neurapulseClient]);
	// Fetch and display project details using projectId

	return (
		<div ref={ref}>
			{loading && <LoadingIndicator />}
			{!loading && error && (
				<div className={clsx(styles.error)} role="alert">
					{error}
				</div>
			)}
			{!loading && !error && project && (
				<Tag>{`${
					project.name
				} (${project.dateCreated.toLocaleDateString()})`}</Tag>
			)}
		</div>
	);
});
